import { createFileRoute } from "@tanstack/react-router";
import { LegalDoc } from "@/components/LegalDoc";

export const Route = createFileRoute("/privacy-policy")({
  component: () => <LegalDoc doc="privacy" />,
});
